<template>
  <div class="pa-2">
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else-if="filteredTickets.length">
      <template v-for="ticket in filteredTickets">
        <ticket-item :key="ticket.id" :value="ticket" :pageid="pageid"></ticket-item>
      </template>
    </div>
    <div v-else class="text-xs-center">
      <div class="headline primary--text">ไม่พบข้อมูล</div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import TicketItem from './TicketItem'
export default {
  props: ['value', 'byadminid', 'filter', 'pageid'],
  components: {
    TicketItem,
  },
  data() {
    return {
      loading: false,
      tickets: [],
    }
  },
  async mounted() {
    this.loading = true

    if (this.$store.state.privilege) {
      var filter = {}
      var view_ticket = this.$store.state.privilege.view_ticket
      if (view_ticket == 'all') {
        // dont do shit
      } else if (view_ticket == 'only_me') {
        Object.assign(filter, {
          assignadminid: this.$store.state.userid,
        })
      } else if (view_ticket == 'only_group') {
        Object.assign(filter, {
          assigngroupid: this.$store.state.admingroupid,
        })
      } else if (view_ticket == 'only_subgroup') {
        Object.assign(filter, {
          assignsubgroupid: this.$store.state.adminsubgroupid,
        })
      }
    }

    if (this.byadminid) {
      var response = await this.getTicketByAdminId()
    } else {
      console.log(filter)
      var response = await this.getTicketListByUser(filter)
    }

    if (response.data && response.data.length > 0) {
      this.tickets = response.data
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
    }),
    filteredTickets() {
      var result
      if (this.$store.state.privilege) {
        switch (this.$store.state.privilege.view_ticket) {
          case 'all':
            result = this.tickets
            break
          case 'only_me':
            result = this.tickets.filter((el) => {
              return el.assignadminid == this.$store.state.userid
            })
            break
          case 'only_group':
            result = this.tickets.filter((el) => {
              return el.assigngroupid == this.$store.state.admingroupid
            })
            break
          case 'only_subgroup':
            result = this.tickets.filter((el) => {
              return el.assignsubgroupid == this.$store.state.adminsubgroupid
            })
            break
          default:
            result = []
        }
      } else {
        result = []
      }
      if (this.filter) {
        result = result.filter((el) => el.status == this.filter)
      }
      return result
    },
  },
  methods: {
    getTicketListByUser(filter = []) {
      var data = {
        userid: this.value,
        pageid: this.pageid,
        ...filter,
      }
      return new Promise((resolve, reject) => {
        api.getTicketListByUser(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTicketByAdminId() {
      var data = {
        adminid: this.value,
        pageid: this.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getTicketByAdminId(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/TicketList.vue